// src/router/index.js
// ZMIANY: usunięty PayNow (/paynowstatus), dodany redirect dla starego URL

import { createRouter, createWebHistory } from 'vue-router'

import AppProductList      from '../components/AppProductList.vue'
import AppProductDetail    from '../components/AppProductDetail.vue'
import AppNewsletter       from '../components/AppNewsletter.vue'
import AppProductCard      from '@/components/AppProductCard.vue'
import AppCart             from '../components/AppCart.vue'
import AppCheckout         from '../components/AppCheckout.vue'
import AppOrderConfirmation from '../components/AppOrderConfirmation.vue'
import AppKontakt          from '../components/AppKontakt.vue'
import AppWysylka          from '../components/AppWysylka.vue'
import AppZwroty           from '../components/AppZwroty.vue'
import AppRegulamin        from '../components/AppRegulamin.vue'
import AppPolityka         from '../components/AppPolityka.vue'
import AppUslugi           from '../components/AppUslugi.vue'
import AppStripeStatus     from '@/components/AppStripeStatus.vue'
import AppCategoryList     from '@/components/AppCategoryList.vue'

const routes = [
  { path: '/',                name: 'Home',             component: AppCategoryList },
  { path: '/product/:slug',   name: 'ProductDetail',    component: AppProductDetail, props: true },
  { path: '/card',            name: 'ProductCard',      component: AppProductCard },
  { path: '/newsletter',      name: 'Newsletter',       component: AppNewsletter },
  { path: '/cart',            name: 'Cart',             component: AppCart },
  { path: '/podsumowanie',    name: 'Podsumowanie',     component: AppCheckout },
  { path: '/potwierdzenie',   name: 'OrderConfirmation',component: AppOrderConfirmation },
  { path: '/kontakt',         name: 'Kontakt',          component: AppKontakt },
  { path: '/wysylka',         name: 'Wysylka',          component: AppWysylka },
  { path: '/zwrot',           name: 'Zwrot',            component: AppZwroty },
  { path: '/regulamin',       name: 'Regulamin',        component: AppRegulamin },
  { path: '/polityka',        name: 'Polityka',         component: AppPolityka },
  { path: '/uslugi',          name: 'Uslugi',           component: AppUslugi },
  { path: '/blog/:slug', name: 'BlogPost', component: () => import('@/components/AppBlogPost.vue') },
  { path: '/blog/:slug', name: 'BlogPost', component: () => import('@/components/AppBlogPost.vue') },
  { path: '/stripe-status',   name: 'StripeStatus',     component: AppStripeStatus },
  { path: '/category', name: 'AllProducts', component: () => import('@/components/AppAllProducts.vue') },
  { path: '/category/:slug',  name: 'CategoryProducts', component: AppProductList },

  // PayNow usunięty – redirect na stronę główną gdyby ktoś miał stary link
  { path: '/paynowstatus', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, top: 0 }
    return { left: 0, top: 0 }
  },
})

export default router
